import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import ErrorPage404 from "../Pages/ErrorPage404";
import { useContext } from "react";
import UserContext from "../_helper/User";

const VerifiedRoute = ({ children }) => {

    const {id, verified} = useContext(UserContext);

    if ((!!id && !verified)) {
        let to = `${process.env.PUBLIC_URL}/verification`;
        return <Navigate exact to={to} />;
    }

    return children;
};
export default VerifiedRoute;